const get = require('lodash.get');
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const states = {
  CA: 'CALIFORNIA',
  FL: 'FLORIDA',
  NV: 'NEVADA',
  IL: 'ILLINOIS',
  UT: 'UTAH',
  NC: 'NORTH CAROLINA',
  VA: 'VIRGINIA',
  HI: 'HAWAII',
  AZ: 'ARIZONA',
  NM: 'NEW MEXICO',
  TN: 'TENNESSEE',
  GA: 'GEORGIA',
  DE: 'DELAWARE',
  MA: 'MASSACHUSETTS',
  NJ: 'NEW JERSEY',
  CT: 'CONNECTICUT',
  MN: 'MINNESOTA',
  SC: 'SOUTH CAROLINA',
  ID: 'IDAHO',
  WA: 'WASHINGTON',
  AK: 'ALASKA',
  OH: 'OHIO',
  NY: 'NEW YORK',
  PA: 'PENNSYLVANIA',
  WI: 'WISCONSIN',
  IN: 'INDIANA',
  MD: 'MARYLAND',
  OK: 'OKLAHOMA',
  MI: 'MICHIGAN',
  MS: 'MISSISSIPPI',
  TX: 'TEXAS',
  RI: 'RHODE ISLAND',
  OR: 'OREGON',
  MT: 'MONTANA',
  IA: 'IOWA',
  LA: 'LOUISIANA',
  SD: 'SOUTH DAKOTA',
  MO: 'MISSOURI',
  DC: 'DISTRICT OF COLOMBIA',
  AL: 'ALABAMA',
  NE: 'NEBRASKA',
  CO: 'COLORADO',
  AR: 'ARKANSAS',
  KS: 'KANSAS',
  WY: 'WYOMING',
  KY: 'KENTUCKY',
  NH: 'NEW HAMPSHIRE',
  ND: 'NORTH DAKOTA',
  WV: 'WEST VIRGINIA',
  ME: 'MAINE',
  VT: 'VERMONT'
};

const statesToAbbr = {
  California: 'CA',
  Florida: 'FL',
  Nevada: 'NV',
  Illinois: 'IL',
  Utah: 'UT',
  'North Carolina': 'NC',
  Virginia: 'VA',
  Hawaii: 'HI',
  Arizona: 'AZ',
  'New Mexico': 'NM',
  Tennessee: 'TN',
  Georgia: 'GA',
  Delaware: 'DE',
  Massachusetts: 'MA',
  'New Jersey': 'NJ',
  Connecticut: 'CT',
  Minnesota: 'MN',
  'South Carolina': 'SC',
  Idaho: 'ID',
  Washington: 'WA',
  Alaska: 'AK',
  Ohio: 'OH',
  'New York': 'NY',
  Pennsylvania: 'PA',
  Wisconsin: 'WI',
  Indiana: 'IN',
  Maryland: 'MD',
  Oklahoma: 'OK',
  Michigan: 'MI',
  Mississippi: 'MS',
  Texas: 'TX',
  'Rhode Island': 'RI',
  Oregon: 'OR',
  Montana: 'MT',
  Iowa: 'IA',
  Louisiana: 'LA',
  'South Dakota': 'SD',
  Missouri: 'MO',
  'District of Colombia': 'DC',
  Alabama: 'AL',
  Nebraska: 'NE',
  Colorado: 'CO',
  Arkansas: 'AR',
  Kansas: 'KS',
  Wyoming: 'WY',
  Kentucky: 'KY',
  'New Hampshire': 'NH',
  'North Dakota': 'ND',
  'West Virginia': 'WV',
  Maine: 'ME',
  Vermont: 'VT'
};

export const notificationPaths = [
  {
    name: 'Ask for review',
    path: 'ask-for-review'
  },
  {
    name: 'Ask to update',
    path: 'ask-to-update'
  },
  {
    name: 'Dashboard',
    path: 'tabs/dashboard'
  },
  {
    name: 'Charges',
    path: 'tabs/activity/charges'
  },
  {
    name: 'Transactions',
    path: 'tabs/activity/transactions'
  },
  {
    name: 'Trip planner',
    path: 'tabs/trip-plan'
  },
  {
    name: 'Vehicles',
    path: 'vehicles'
  },
  {
    name: 'Add vehicle',
    path: 'vehicles/add'
  },
  {
    name: 'Add payment method',
    path: 'wallet/add-payment-method'
  },
  {
    name: 'Promotions',
    path: 'promotions'
  },
  {
    name: 'Refer a friend',
    path: 'promotions/referral'
  },
];

const parseErrorStatus = (error) => (error?.statusText || '').toLowerCase().replace(/\s/g, '-');

const parseErrorMessage = (error) =>
  get(error, 'error.error', get(error, 'error.message', get(error, 'error', get(error, 'message', error))));

export const handleAPIError = error => {
  try {
    error = parseErrorMessage(error);
  }
  catch (_) { }
  throw error;
};

export const errorText = (error: any): string => {
  if (typeof error === 'string') {
    return error;
  }
  const err = parseErrorMessage(error);
  return parseErrorStatus(err) || err;
};

export const dateToNgbDate = (date?: Date | string): NgbDateStruct => {
  const _date = date ? new Date(date) : undefined;
  return _date ? {
    year: _date.getFullYear(),
    month: _date.getMonth() + 1,
    day: _date.getDate()
  } : undefined;
};

export const toFormData = (data: any, formData = new FormData()) => {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      }
      else {
        formData.append(key, value);
      }
    }
  }
  return formData;
};

export type sortOrder = 'ascending' | 'descending';

export interface ISearchParams {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: sortOrder;
}

export const filterParams = <T>(obj: T) => {
  const res: Partial<T> = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (value) {
      res[key] = value;
    }
  });
  return res;
};

export const defaultPage = (page?: string) => parseInt(page || '1', 10);

export const startOfDay = (date?: Date) => {
  if (!date) {
    return undefined;
  }
  date.setHours(0, 0, 0, 0);
  return date.toJSON();
};

export const endOfDay = (date?: Date) => {
  if (!date) {
    return undefined;
  }
  date.setHours(23, 59, 59, 99);
  return date.toJSON();
};

export const lastMonth = (now = new Date()) => {
  const date = new Date(now);
  date.setMonth(date.getMonth() - 1);
  return date;
};

export const yearsMonthsDays = (date: Date | string) => {
  const to = typeof date === 'string' ? date : new Date(date).toISOString();
  return to.substring(0, 10);
};

export const remove = (str, toRemove) =>
  str.replace('"', '').replace(toRemove, '').replace(/\s/g, '').replace('"', '');

// eslint-disable-next-line complexity
export const formatAMPM = (dt) => {
  const date = new Date(dt);
  let hours: any = date.getHours();
  let minutes: any = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const d = date.toLocaleDateString('en-US');
  const split = d.split('/');
  const day = split[1].length === 1 ? `0${split[1]}` : split[1];
  return `${split[0]}/${day}/${split[2]}` + ' ' + hours + ':' + minutes + ' ' + ampm;
};

export const isEZPassPending = (network) => network.statuses.length === 1;

export const getEzpassVehicles = (vehicles) =>
  vehicles.filter(vehicle => vehicle.networks.find(network => network.name === 'E-ZPass'));

// eslint-disable-next-line complexity
export const shouldRemove = (limitDate, vehicle, network, fleet_on_ipass) => {
  const suspendedStatus = network?.statuses.filter(status => status.state === 'suspended') || [];

  if (suspendedStatus.length === 0) {
    return false;
  }

  const suspendedDate = new Date(suspendedStatus[suspendedStatus.length - 1].startDate);

  if (suspendedDate < limitDate) {
    return false;
  }

  const alreadyPresent = fleet_on_ipass.find(
    v => v.license === vehicle.license && v.licensePlateState === vehicle.licenseState
  );

  if (!alreadyPresent) {
    // if a vehicle is not present, we cant suspend it
    return false;
  }

  if (alreadyPresent && alreadyPresent.endDate) {
    const hours = (alreadyPresent.endDate.getTime() - suspendedDate.getTime()) / 3600000;
    if (hours < 24) {
      return false;
    }
  }

  return true;
};

// eslint-disable-next-line complexity
export const shouldAdd = (limitDate, vehicle, network, fleet_on_ipass) => {
  const authorizedStatus = network?.statuses.find(status => status.state === 'authorized');

  if (!authorizedStatus) {
    return false;
  }

  const authorizedDate = new Date(authorizedStatus.initiationDate);

  if (authorizedDate < limitDate) {
    return false;
  }

  const suspendedStatus = network?.statuses.filter(status => status.state === 'suspended') || [];

  if (suspendedStatus.length !== 0) {
    const suspendedDate = new Date(suspendedStatus[suspendedStatus.length - 1].startDate);
    if (suspendedDate < limitDate || suspendedDate < authorizedDate) {
      return false;
    }
  }

  const alreadyPresent = fleet_on_ipass.find(
    v => v.license === vehicle.license && v.licensePlateState === vehicle.licenseState
  );

  return !alreadyPresent;
};

// eslint-disable-next-line complexity
export const getVehiclesData = (vehicles, combos, action) => {
  let res = '';
  for (const veh of vehicles) {
    const v = veh.vehicle;
    const network = combos.find(combo => combo.network.vin === v.vin).network;
    const authorizedStatus = network?.statuses.find(status => status.state === 'authorized');
    const suspendedStatus = network?.statuses.filter(status => status.state === 'suspended') || [];
    const startDate = authorizedStatus.initiationDate ?
      formatAMPM(authorizedStatus.initiationDate) :
      formatAMPM(authorizedStatus.startDate);
    const endDate = suspendedStatus.length !== 0 ?
      formatAMPM(suspendedStatus[suspendedStatus.length - 1].startDate) : '';
    const rental = startDate !== '' && endDate !== '' ? 'X' : '';
    const state = states[v.licenseState];
    res = res + `${action};"${v.license}";USA;${state};Passenger;AU - Auto / Motorcycle (2 Axles);${rental};${startDate};${endDate}\n`;
  }
  return res;
};

export const newFormatFleet = (rawVehicle) => {
  const split = rawVehicle.split(',');
  let startDate = (split[6]+split[7]).replace('\"', '').replace('\"', '');
  startDate = new Date(startDate);
  let endDate = split[8].replace('\"', '').replace('\"', '');
  endDate = endDate === '-' ? undefined : new Date(endDate + split[9].replace('\"', ''));
  return {
    license: split[0].replace('\"', '').replace('\"', ''),
    licensePlateCountry: split[3].replace('\"', '').replace('\"', ''),
    licensePlateState: statesToAbbr[split[4].replace('\"', '').replace('\"', '')],
    startDate,
    endDate
  };
};

export const formatFleet = (rawVehicle) => {
  const split = rawVehicle.split(',');

  let startDate = split[6].replace('"', '').replace('Start Date and Time', '').replace('"', '');
  startDate = new Date(startDate.substring(2, 25));
  let endDate = split[7].replace('"', '').replace('End Date and Time', '').replace('"', '').replace('r');
  endDate = endDate.length === 3 ? undefined : new Date(endDate.substring(2, 25));
  return {
    license: remove(split[3], 'License Plate'),
    licensePlateCountry: remove(split[4], 'Country'),
    licensePlateState: remove(split[5], 'State'),
    startDate,
    endDate
  };
};

const dateToWSDOT = (dateStr) => {
  const split = dateStr.split('-');
  return `${split[1]}/${split[2]}/${split[0]}`;
};

// eslint-disable-next-line complexity
export const processWSDOTVehicle = (combo) => {
  const vehicle = combo.vehicle;
  const network = combo.network;
  const authorizedStatus = network?.statuses.find(status => status.state === 'authorized');
  const suspendedStatus = network?.statuses.filter(status => status.state === 'suspended') || [];

  const startSplit: string[] = authorizedStatus.startDate.split('T');
  const startDate = `"${dateToWSDOT(startSplit[0])}"`;
  const startTime = `"${startSplit[1].substring(0, 5)}"`;

  if (suspendedStatus.length !== 0 && new Date(suspendedStatus[suspendedStatus.length-1].startDate) < new Date()) {
    return null;
  }
  const endSplit: string[] = suspendedStatus.length === 0 ? undefined : suspendedStatus[suspendedStatus.length-1].startDate.split('T');
  const endDate = endSplit !== undefined ? `"${dateToWSDOT(endSplit[0])}"` : '';
  const endTime = `"${endSplit !== undefined ? endSplit[1].substring(0, 5) : ''}"`;

  const time = `${startDate},${startTime},${endDate},${endTime}`;
  return `${vehicle.licenseState},US,PASS,NO,${vehicle.license},${vehicle.make},${vehicle.vehicleModel},${vehicle.modelYear},,,${time}`;
};

